module.exports = __webpack_public_path__ + "static/0070-7dd34cb3b39cbc8be6d310467d8325f0.png";